import Component from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import EdPresentationModeFactory from '@/content/factories/ed-presentation-mode.factory';
import WebSocketMessageResponse from '@/content/models/web-socket-message-response.model';
import WebSocketMessageRequest from '@/content/models/web-socket-message-request.model';
import { FORWARD_PRESENTATION_MESSAGES_EVENT, _APP_STORE } from '@/core/values/app.values';
import * as PRESENTATION_VALUES from '@/content/values/ed-presentation-mode.values';
import { AUTH_STORE } from '@/auth/store/auth.store';
import { MEETINGS_STORE } from '@/meetings/store/meetings.store';
import PresentationModeViewerMixin from '@/content/mixins/ed-presentation-mode-viewer.mixin';
import { EdJitsiMixin } from '@/components/screen-share/ed-screen-share/ed-jitsi-mixin'

@Component({})
export default class EdPresentationModeGuestTeacher extends Mixins(PresentationModeViewerMixin, EdJitsiMixin) {

  get isActivePresenterTeacher() : boolean {
    return this.$store.state.MeetingsStore.isActivePresenterTeacher;
  }

  /**
   * @override
   * @param data
   * @returns
   */
  public async loadInitialDocument(data: WebSocketMessageResponse): Promise<void> {
    this.isObtainInitialCourse = false;
    if (data.error) {
      this.showErrorMessage();
      return;
    }

    if(this.isInitialLoaded || !this.isActivePresenterTeacher){
      return;
    }

    if(!(data && data.messages && Object.keys(data.messages).length > 0)){
      setTimeout(() => this.obtainInitialCourse(), 1000);
      return;
    }

    this.isInitialLoaded = true;
    this.messageHigher = null;

    for (let key in data.messages) {
      if (!this.messageHigher || data.messages[key].time > this.messageHigher.time) {
        this.messageHigher = data.messages[key];
      }
    }

    this.validateBasicMessages();
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_INITIAL_PRESENTATION_MODE_MESSAGE, this.messageHigher);
  }

  /**
  * @override
  */
  public validateConnection(): void {
    if (!this.isLoading) {
      this.$EdToast.hide();
    }

    if (this.isLoading) {
      this.validateObtainInitialValues();
      this.showMessageNotDocument();
    }
  }

  private obtainInitialCourse(): void {
    if (this.isObtainInitialCourse) {
      return;
    }
    this.isObtainInitialCourse = true;
    let message: WebSocketMessageRequest = EdPresentationModeFactory.createWebSocketMessageRequestWithUserType(PRESENTATION_VALUES.EVENT_TYPES.all, String(this.roomId), PRESENTATION_VALUES.GUEST_TACHER_ROLE);
    this.$EdSocket.emit(PRESENTATION_VALUES.SOCKET_EVENTS.connect, message);
    this.validateMeetingStatus();
  }

  private validateMeetingStatus(): void {
    if (this.isActivePresenterTeacher && this.sectionMaterial === null && this.internalSection === null) {
      this.showMessageNotDocument();
    } else if (!this.isActivePresenterTeacher) {
      this.leaveTeacherPresentation();
    }
  }

  private async processMessage(message: WebSocketMessageResponse): Promise<boolean> {
    if (!this.isInitialResize) {
      if(!this.isActivePresenterTeacher && message && message.messageType === PRESENTATION_VALUES.EVENT_TYPES.subscribe && message.topicId === this.roomId){
        this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_ACTIVE_PRESENTER_TEACHER, true);
        this.validateConnection();
      }
      return;
    }
    if( this.isRemoteSharingScreen ) {
      return;
    }
    if (message && message.messageType && this.processors[message.messageType] && message.topicId === this.roomId) {
      let data = message.content ? JSON.parse(message.content) : {};
      return await this.processors[message.messageType](data, true);
    }
  }

  private async leaveTeacherPresentation(): Promise<void> {
    this.genericLeaveTeacherPresentation();
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_ACTIVE_PRESENTER_TEACHER, false);
  }

  private validateParamsToInit(): void {
    if (this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId) {
      this.obtainInitialCourse();
    }
  }

  private validateStoreValues() {
    this.$store.subscribe((mutation) => {
      if (mutation.type === _APP_STORE.MUTATIONS.SET_PRESENTATION_SOCKET_CONNECTED || mutation.type === AUTH_STORE.MUTATIONS.SET_USER_INFO) {
        this.validateParamsToInit();
      }
    });
  }

  private validateObtainInitialValues() {
    if (this.$store.state.AppStore.presentationSocketConnected && this.$store.state.AuthStore.user.userId) {
      this.obtainInitialCourse();
    } else {
      this.validateStoreValues();
    }
  }

  private async forwardMessages(): Promise <void> {
    await this.restoreDefaultValues();
    this.validateConnection();
  }

  @Watch('isRemoteSharingScreen')
  private onRemoteUserIsSharingScreen() {
    if( this.isRemoteSharingScreen ) {
      this.$EdToast.hide();
    } else {
      //when stops sreen sharing then refresh meeting status
      this.forwardMessages();
    }
  }

  mounted() {
    this.validateMeetingStatus();
    this.$edEventBus.$on(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.RESPONSE_EVENT, this.processMessage);
    this.$edEventBus.$on(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT, this.leaveTeacherPresentation);
    this.$edEventBus.$on(FORWARD_PRESENTATION_MESSAGES_EVENT, this.forwardMessages);
  }

  beforeDestroy() {
    this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.RESPONSE_EVENT, this.processMessage);
    this.$edEventBus.$off(PRESENTATION_VALUES.PRESENTATION_MODE_EVENTS.LEAVE_TEACHER_EVENT, this.leaveTeacherPresentation);
    this.$edEventBus.$off(FORWARD_PRESENTATION_MESSAGES_EVENT, this.forwardMessages);
  }
}
